<div class="ai-summary" *ngIf="isLoading || summaryText">

	<div class="ai-summary-icon" aria-hidden="true">
		<i class="bi bi-stars"></i>
	</div>

	<div class="ai-summary-body">
		<div class="ai-summary-title">AI Summary</div>

		<div *ngIf="isLoading" class="ai-summary-loading">
			Reviewing appointment history<span class="ai-summary-dots"></span>
		</div>

		<div *ngIf="!isLoading && summaryText" class="ai-summary-text">
			<p *ngIf="intro" class="ai-summary-intro">{{ intro }}</p>

			<ul *ngIf="bullets.length > 0" class="ai-summary-bullets">
				<li *ngFor="let bullet of bullets">{{ bullet }}</li>
			</ul>
		</div>
	</div>

</div>
